import { axiosClient, getCSRFToken, serializeObject } from 'www/utils'

function getServiceList({ url, data }) {
  return axiosClient({
    method: 'GET',
    url: `${url}?${serializeObject(data)}`,
    headers: {
      'X-CSRFToken': getCSRFToken(),
      'Content-Type': 'application/json',
    },
  })
}

export default getServiceList
